<template>
  <TopGradientBlockLayout class="text-center font-bold">
    <div class="text-sm text-text-secondary mt-0-5 mb-7 relative">
      {{ $t('profitability') }}
      <IconRoundQuestionMark
          class="absolute right-0 top-0 mt-0-5 bg-border-hover rounded-full text-block w-5 h-5"
          v-tooltip="{ content: profitTooltip, classes: '--white' }"/>
    </div>
    <div class="text-text text-xl mb-4">{{ displayedProfitPercentYear }}</div>
    <div class="text-md text-text-ternary">{{ displayedProfitPercentTotal }}</div>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import IconRoundTick from "@/components/icons/IconRoundTick";
import IconRoundQuestionMark from "@/components/icons/IconRoundQuestionMark";
import {mapGetters} from "vuex";

export default {
  name: "Profit",
  components: {IconRoundQuestionMark, IconRoundTick, TopGradientBlockLayout},
  props: {
    profitabilityYear: {
      type: Number,
      required: true
    },
    profitabilityTotal: {
      type: Number,
      required: true
    }
  },
  computed: {
    displayedProfitPercentYear() {
      return `${this.profitabilityYear.toFixed(2)} %`
    },
    displayedProfitPercentTotal() {
      return `${this.profitabilityTotal.toFixed(2)} %`
    },
    profitTooltip() {
      return this.$t('profitTooltip')
    }
  },
  i18n: {
    messages: {
      en: {
        profitability: 'Profitability',
        profitTooltip: 'Above - the average return as % per year,<br> below - the total portfolio return'
      },
      ru: {
        profitability: 'Доходность',
        profitTooltip: 'Вверху - средняя доходность в % годовых,<br> внизу - общая доходность портфеля'
      }
    }
  }
}
</script>